import React from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
  startDate: Date | undefined;
}

export const StartDatePresentor = ({ startDate }: IProps) => {
  const { t } = useTranslation();
  return (
    <div className='floating-input mb-1 relative'>
      <input
        type='text'
        id='periodStart'
        className='border border-bw03 focus:outline-none font-metricR text-bw08 text-[14px] rounded-md focus:border-action03 focus:shadow-sm hover:bg-bw01 w-full p-3 h-12 '
        placeholder='transparent placeholder'
        value={startDate?.toDateString() || ''}
        disabled
      />
      <label
        id='inputLabel-periodStart'
        htmlFor='periodStart'
        className='absolute top-0 left-0 px-3 py-4 h-full pointer-events-none font-metricR transform origin-left transition-all duration-100 ease-in-out'
      >
        {t('TRANSACTIONS_FACELIFT.DATE_PICKER_WRAPPER.FROM')}
      </label>
    </div>
  );
};
